import React from 'react';
import Checkbox from './Checkbox';

interface CheckboxOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface CheckboxGroupProps {
  name: string;
  value: string[];
  onChange: (value: string[]) => void;
  options: CheckboxOption[];
  labelVariant?: 'body' | 'body-small' | 'body-small-bold';
  className?: string;
  style?: React.CSSProperties;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  name,
  value,
  onChange,
  options,
  labelVariant = 'body',
  className,
  style
}) => {
  const handleCheckboxChange = (checkboxValue: string, checked: boolean) => {
    if (checked) {
      // Add to selection
      onChange([...value, checkboxValue]);
    } else {
      // Remove from selection
      onChange(value.filter(v => v !== checkboxValue));
    }
  };

  return (
    <div className={`checkbox-group ${className || ''}`} style={style}>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          checked={value.includes(option.value)}
          onChange={(checked) => handleCheckboxChange(option.value, checked)}
          label={option.label}
          labelVariant={labelVariant}
          disabled={option.disabled}
          id={`${name}-${option.value}`}
        />
      ))}
    </div>
  );
};

export default CheckboxGroup; 